var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.44,.61H3.56c-.93,0-1.69,.76-1.69,1.69v15.19c0,.93,.76,1.69,1.69,1.69h1.69v3.38c0,.33,.19,.62,.49,.76,.11,.06,.23,.09,.36,.08,.2,0,.39-.07,.54-.2l4.83-4.02h4.45c.39,0,.77-.14,1.08-.39l4.52-3.78c.39-.31,.61-.79,.61-1.29V2.3c0-.93-.76-1.69-1.69-1.69h0ZM12,11.58c0,.47-.38,.84-.84,.84s-.84-.38-.84-.84V6.52c0-.47,.38-.84,.84-.84s.84,.38,.84,.84v5.06Zm5.06,0c0,.47-.38,.84-.84,.84s-.84-.38-.84-.84V6.52c0-.47,.38-.84,.84-.84s.84,.38,.84,.84v5.06Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.d951121a.svg";
export { ForwardRef as ReactComponent };